import { FC, useState, useRef } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./carouselStyles.scss";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";
import CarCardComponent from "../carCard/CarCardComponent";

const mapToCarCard = (car: any) => {
    const price = parseFloat(car.price) || 0;
    const discountPrice = parseFloat(car.discount_price) || 0;
    return {
        ...car,
        photoUrl: car.image_first,
        name: car.car,
        brand: { name: car.brand_car?.brand },
        type: { name: car.type?.type },
        odometer: car.mileage,
        transmission: car.transmission === 1 ? "Automática" : "Manual",
        tag: car.tag_car ? { id: car.tag_car.id ?? null, name: car.tag_car.tag, color: car.tag_car.color } : null,
        price,
        discount_price: discountPrice !== 0 ? discountPrice : undefined,
    };
};

export const Carousel1: FC<{ cars: any; carsRelated?: boolean }> = ({ cars, carsRelated = false }) => {
    const [indexCard, setIndexCard] = useState<number>(0);

    const carouselRef = useRef(null);

    const previous = () => {
        if (carouselRef.current && indexCard !== 0) {
            carouselRef.current.goToSlide(indexCard - 1);
            setIndexCard(indexCard - 1);
        }
    };

    const next = () => {
        if (carouselRef.current && indexCard + 1 !== cars?.length) {
            carouselRef.current.goToSlide(indexCard + 1);
            setIndexCard(indexCard + 1);
        }
    };

    const goToIndex = (index: number) => {
        if (carouselRef.current) {
            carouselRef.current.goToSlide(index);
            setIndexCard(index);
        }
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 4000, min: 1300 },
            items: 3,
        },
        tablet: {
            breakpoint: { max: 1300, min: 767 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 767, min: 0 },
            items: 1,
        },
    };

    return (
        <>
            <Carousel
                partialVisible
                ref={carouselRef}
                responsive={responsive}
                removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
                beforeChange={(currentSlide, _) => {
                    setIndexCard(currentSlide);
                }}
            >
                {cars?.map((car: any, i: number) => (
                    <div className="m-3" key={i}>
                        <CarCardComponent car={mapToCarCard(car)} />
                    </div>
                ))}
            </Carousel>
            <div className="container_nav w-80 d-flex">
                <div className={`arrow_slider_card me-1 ${indexCard === 0 ? "disabled" : null}`} onClick={previous}>
                    <AiOutlineArrowLeft />
                </div>
                <div
                    className={`arrow_slider_card ms-1 ${indexCard === cars?.length - 1 ? "disabled" : null}`}
                    onClick={next}
                >
                    <AiOutlineArrowRight />
                </div>
                <div className="container_item_card d-flex flex-wrap justify-content-around align-items-center">
                    {cars?.map((car: any, i: number) => {
                        return (
                            <div
                                className={`item_card ${indexCard === i ? "active" : "disabled"}`}
                                key={i}
                                onClick={() => goToIndex(i)}
                            ></div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};
